export default "__VITE_ASSET__CGpFlQQ5__"